import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-CN.json';
import zhTW from './locales/zh-TW.json';
import en from './locales/en.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import th from './locales/th.json';
import id from './locales/id.json';
import vi from './locales/vi.json';
import hi from './locales/hi.json';
import ms from './locales/ms.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'zh-TW': { translation: zhTW },
    en: { translation: en },
    ja: { translation: ja },
    ko: { translation: ko },
    th: { translation: th },
    id: { translation: id },
    vi: { translation: vi },
    hi: { translation: hi },
    ms: { translation: ms },
    es: { translation: es },
    pt: { translation: pt },
  },
  lng: localStorage.getItem('i18nextLng') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
